import React, { Component } from "react";
import ProductDetails from "../components/ProductDetails";
import { fetchProduct } from "../api";
import { connect } from "react-redux";

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: null
    };
  }

  get sku() {
    return this.props.match.params.sku;
  }

  async componentDidMount() {
    //if the finance type is CASH, then subtype will be sent as NULL
    //otherwise, if not cash, but subtype is NULL, then send as RENTAL
    var financeSubtype = this.props.quote.finance.financeSubtype;
    if(this.props.quote.finance.financeType === "CASH") {
      financeSubtype = null;
    }
    else if(financeSubtype === null) {
      financeSubtype = "RENTAL"
    }

    var product = await fetchProduct(
      this.sku,
      this.props.quote.customerGroupId,
      this.props.quote.sfdcCustomerNumber,
      this.props.quote.finance.financeType,
      financeSubtype
    )
    product.options.forEach(opt => opt.selections.forEach(sel => { sel.targetPrice = Number(sel.product.price); sel.financeType = "CASH"} ))
    this.setState({
      product: product
    });
  }

  render() {
    return this.state.product ? (
      <ProductDetails
        product={this.state.product}
        opportunity={this.props.opportunity}
        oldQuoteItem={this.props.oldQuoteItem}
        history={this.props.history}
      />
    ) : null;
  }
}

export default connect(({ opportunity, quote }) => ({
  opportunity,
  quote,
  oldQuoteItem:
    quote.items.find(item => {
      let queries = new URLSearchParams(window.location.search);
      return item.key === queries.get("quoteItemKey");
    }) || null
}))(Product);
